// Amateur Topic 7 — Supply and Demand. Notes + infographics (scenes in scenes/advanced.jsx).
export default {
  title: 'Supply and Demand',
  summary: 'Zones where big buyers and sellers are waiting.',
  subtopics: [
    { title: 'What It Is', scene: 'sdWhat', cards: [
      { icon: '🛒', title: 'Demand = buyers', body: 'A demand zone is where lots of buyers bought before. Price jumped up from there.' },
      { icon: '🏷️', title: 'Supply = sellers', body: 'A supply zone is where lots of sellers sold before. Price fell from there.' },
      { icon: '🐋', title: 'Big players', body: 'Banks and funds buy and sell in huge amounts. They often leave orders waiting in these zones.' },
      { icon: '📦', title: 'A zone, not a line', body: 'We draw supply and demand as a box (an area), not a thin line.' },
    ] },
    { title: 'Identifying Zones', scene: 'sdIdent', cards: [
      { icon: '⬆️⏸️⬇️', title: 'Rally-Base-Drop', body: 'Up fast, small rest, down fast. The rest (base) is a SUPPLY zone.' },
      { icon: '⬇️⏸️⬆️', title: 'Drop-Base-Rally', body: 'Down fast, small rest, up fast. The base is a DEMAND zone.' },
      { icon: '➡️', title: 'Continuation zones', body: 'Rally-Base-Rally (demand) and Drop-Base-Drop (supply) happen in the middle of a trend.' },
      { icon: '🚀', title: 'Fast exit = strong zone', body: 'The faster and bigger the move away from the base, the stronger the zone.' },
    ] },
    { title: 'Trading From a Zone', scene: 'sdTrade', cards: [
      { icon: '⏳', title: 'Wait for the return', body: 'Do not chase. Wait for price to come back to the zone.' },
      { icon: '🥇', title: 'First touch is best', body: 'The first return is usually strongest. Each touch uses up the waiting orders.' },
      { icon: '🛑', title: 'Stop beyond the zone', body: 'Buy at demand with a stop just below it. Sell at supply with a stop just above it.' },
      { icon: '🎯', title: 'Target the next zone', body: 'Aim for the next opposite zone. Gold example: buy demand 2,350–2,368, stop 2,340, target supply near 2,448.' },
    ] },
    { title: 'How It Differs From SNR', scene: 'sdVsSnr', cards: [
      { icon: '📏', title: 'SNR is a line', body: 'Support and resistance is a level price touched many times.' },
      { icon: '📦', title: 'S&D is a zone', body: 'Supply and demand is a box where one strong move started.' },
      { icon: '🔢', title: 'Touches mean different things', body: 'For SNR, more touches = stronger. For S&D, fewer touches = fresher and stronger.' },
      { icon: '🤝', title: 'Use them together', body: 'A zone that sits on an old SNR level is extra strong.' },
    ] },
  ],
};
